import { render, staticRenderFns } from "./ComplianceElementScoreOverTimeDrillDown.vue?vue&type=template&id=20cdc8cb&"
import script from "./ComplianceElementScoreOverTimeDrillDown.vue?vue&type=script&lang=ts&"
export * from "./ComplianceElementScoreOverTimeDrillDown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports